import React, { useState } from "react";

import { Button } from "antd";

import "./DataFieldsEditModal.css";

export default function DataFieldsEditModal(props) {
  const {
    field, toggleShowEditModal, handleEdit, refVal,
  } = props;
  const [newField, setNewField] = useState(field);
  const handleHitEnter = (e) => {
    if (e.key === "Enter") {
      handleEdit(field, newField.trim());
    }
  };
  return (
    <div ref={refVal} className="editModal">
      <div className="editModalInputContainer">
        <input className="editModal_formInput" type="text" placeholder="Enter title" name="datafield" onKeyUp={(e) => handleHitEnter(e)} value={newField} onChange={(e) => setNewField(e.target.value)} />
      </div>
      <div className="editModalButtonContainer">
        <Button type="default" onClick={() => toggleShowEditModal()}>Cancel</Button>
        <Button type="primary" onClick={() => handleEdit(field, newField.trim())}>Save</Button>
      </div>

    </div>
  );
}
